"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useActiveElement = _interopRequireDefault(require("../useActiveElement"));
var _selectorSafe = _interopRequireDefault(require("../../utils/selectorSafe"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useTypedownToggle = name => {
  const [open, setOpen] = (0, _react.useState)(false);
  const onToggle = (0, _react.useCallback)(() => {
    setOpen(!open);
  }, [open, setOpen]);
  const {
    hasParent
  } = (0, _useActiveElement.default)();

  // Trawl up element stack and check if a typedown-parent exists, use that to toggle
  const openBool = !open && hasParent(`typedown-parent-${(0, _selectorSafe.default)(name)}`);
  const closeBool = open && !hasParent(`typedown-parent-${(0, _selectorSafe.default)(name)}`);
  (0, _react.useEffect)(() => {
    if (openBool || closeBool) {
      onToggle();
    }
  }, [closeBool, onToggle, openBool]);
  return {
    open,
    onToggle
  };
};
var _default = exports.default = useTypedownToggle;